import 'core-js/stable'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'leaflet/dist/leaflet.css'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/index.scss'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

store.dispatch('auth/restore').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
